/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteCostcoProductLog200ResponseAllOfData } from './DeleteCostcoProductLog200ResponseAllOfData';
import {
    DeleteCostcoProductLog200ResponseAllOfDataFromJSON,
    DeleteCostcoProductLog200ResponseAllOfDataFromJSONTyped,
    DeleteCostcoProductLog200ResponseAllOfDataToJSON,
} from './DeleteCostcoProductLog200ResponseAllOfData';

/**
 * 
 * @export
 * @interface DeleteCostcoProductLog200Response
 */
export interface DeleteCostcoProductLog200Response {
    /**
     * 
     * @type {DeleteCostcoProductLog200ResponseAllOfData}
     * @memberof DeleteCostcoProductLog200Response
     */
    data: DeleteCostcoProductLog200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof DeleteCostcoProductLog200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the DeleteCostcoProductLog200Response interface.
 */
export function instanceOfDeleteCostcoProductLog200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function DeleteCostcoProductLog200ResponseFromJSON(json: any): DeleteCostcoProductLog200Response {
    return DeleteCostcoProductLog200ResponseFromJSONTyped(json, false);
}

export function DeleteCostcoProductLog200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCostcoProductLog200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': DeleteCostcoProductLog200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function DeleteCostcoProductLog200ResponseToJSON(value?: DeleteCostcoProductLog200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteCostcoProductLog200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

